/* istanbul ignore file */
import React, { useCallback, useState } from 'react';
import { CreateForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import useProcessVariableService from 'domain/gpo/cockpit/instance/Show/variables/processVariablesService';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import AddProcessVariableForm from 'domain/gpo/cockpit/instance/Show/variables/shared/AddProcessVariableForm';

const MESSAGE_CONTEXT = 'AddProcessVariableModalForm';

interface AddProcessVariableModalFormProps {
  closeModal: () => void;
}

const AddProcessVariableModalForm = ({ closeModal }: AddProcessVariableModalFormProps) => {
  const processInstanceId = useProcessInstanceId();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const { create, getValidationSchema } = useProcessVariableService();

  const closeForm = useCallback(() => {
    setIsModalOpen(false);
    closeModal();
  }, [setIsModalOpen, closeModal]);

  return (
    <CreateForm
      submitFormFunc={create}
      messageContext={MESSAGE_CONTEXT}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        instanceId: processInstanceId,
        objectTypeName: null,
        type: null,
      }}
      afterSubmit={{
        execute: closeForm,
      }}
    >
      <Modal
        key="modal-not-strict"
        modalSize="sm"
        backdrop="static"
        keyboard={false}
        isOpen={isModalOpen}
        hasCancelButton={false}
        title="Add variable"
        onToggle={closeForm}
      >
        <AddProcessVariableForm handleCancelClick={closeForm} />
      </Modal>
    </CreateForm>
  );
};

export default AddProcessVariableModalForm;
